export default __webpack_public_path__ + "static/media/bti-img.5455b747.webp";